import React, { useCallback, useState } from "react";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { TradeLeg } from "../../../components/TradeLeg/TradeLeg";
import {
  TokenSelectModal,
  TokenSelectMode,
} from "../../../components/Modal/instance/SelectTokenModal/TokenSelectModal";
import { Token } from "../../../store/global/TokenEnum";
import { SelectTokensButton } from "./SelectTokensButton";
import { Amount } from "../../../types/amount";

export const TakerSection: React.FC = () => {
  const takerTokens = GlobalStore.useState(s => s.takerTokens);
  const makerTokens = GlobalStore.useState(s => s.makerTokens);
  const tokenSelectMode: TokenSelectMode = makerTokens.length > 1 ? "single" : "multiple";
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const compareSelectedTokens = (oldTokens: Array<Token>, newTokens: Array<Token>) => {
    const added = [];
    const deleted = [];
    // Find added elements
    for (const item of newTokens) {
      if (!oldTokens.includes(item)) {
        added.push(item);
      }
    }
    // Find deleted elements
    for (const item of oldTokens) {
      if (!newTokens.includes(item)) {
        deleted.push(item);
      }
    }

    return [deleted, added];
  };
  const handleOnTokensSelected = useCallback((tokens: Array<Token>) => {
    GlobalStore.update(s => {
      // Diff old tokens with new tokens first - so we don't wipe amount
      const [deleted, added] = compareSelectedTokens(
        s.takerTokens.map(e => e.token),
        tokens
      );
      const afterDeletedTokens = s.takerTokens.filter(entry => {
        return !deleted.includes(entry.token);
      });

      const addedTokens = added.map(entry => {
        return { token: entry, amount: Amount.ZERO };
      });
      s.isRequestingQuote = false;
      s.quote = undefined;
      s.takerTokens = [...afterDeletedTokens, ...addedTokens];
    });
  }, []);
  return (
    <>
      <TokenSelectModal
        counterParty={"taker"}
        isOpen={modalOpen}
        onSelected={tokens => handleOnTokensSelected(tokens)}
        tokenSelectMode={"multiple"}
        onClose={() => {
          setModalOpen(false);
        }}
      />
      <div className="d-flex justify-content-between">
        <div className="trade-box-header">You Pay</div>
        <div className="sp24"></div>
      </div>
      {/* Show a trade leg if we don't have any tokens initially*/}
      {takerTokens.length === 0 ? (
        <TradeLeg
          key={"tokenSelect"}
          counterParty={"taker"}
          symbol={undefined}
          tokenSelectMode={tokenSelectMode}
        />
      ) : null}
      <div data-testid="taker-trade-legs-section">
        {takerTokens.map(entry => {
          return (
            <TradeLeg
              key={entry.token}
              symbol={entry.token}
              tokenSelectMode={"single"}
              counterParty={"taker"}
            />
          );
        })}
        <div className="symbol-Add-standard">
          <SelectTokensButton
            visible={makerTokens.length <= 1 && takerTokens.length > 0}
            onClick={() => setModalOpen(true)}
          />
        </div>
      </div>
    </>
  );
};
